/*
 * See https://vite.dev/guide/env-and-mode for more information on environment variables with Vite.
 *
 * Note that Vite's import.meta.env isn't available to Jest's unit tests, meaning that any tests
 *  of components which reference this file (even indirectly) should mock it:
 * jest.mock('../helpers/environment', () => ({ ... }))
*/

import { formatDate, formatTimestamp } from './format'

export const isDevEnvironment = (): boolean => {
    return import.meta.env.DEV
}

export const getApiEndpointUrl = (): string => {
    // Read an environment variable built into the scripts.
    if (import.meta.env.VITE_API_ENDPOINT !== undefined) {
        return import.meta.env.VITE_API_ENDPOINT
    }
    // If none found, assume we're on a dev machine.
    return 'http://localhost:3042'
}

export const getServerRoot = (): string => {
    const path = window.location.href
    return path.substring(0, path.indexOf('/', 8) + 1)
}

export const currentCommitLink = (): string =>
    `https://github.com/${
        import.meta.env.VITE_PROJECT_USERNAME || 'mm689'
    }/${
        import.meta.env.VITE_PROJECT_REPONAME || 'trove'
    }/tree/${
        import.meta.env.VITE_SHA1 || 'main'
    }/`

export const currentCommitHash = (): string => import.meta.env.VITE_SHA1?.substring(0, 8) || '<development>'

export const currentCommitLabel = (): string => `${currentCommitHash()} on ${import.meta.env.VITE_BRANCH || '<unknown branch>'}`

export const hasBuildTimestamp = (): boolean => !!import.meta.env.VITE_BUILD_TIMESTAMP

export const currentBuildTimestamp = (admin = false): string => {
    if (!hasBuildTimestamp() || typeof import.meta.env.VITE_BUILD_TIMESTAMP !== 'string') {
        return ''
    }
    const timestamp = new Date(import.meta.env.VITE_BUILD_TIMESTAMP)
    return admin ? `${formatDate(timestamp, 'short')} at ${formatTimestamp(timestamp)}` : formatDate(timestamp, 'long')
}

export const buildLogLink = (): string => import.meta.env.VITE_BUILD_URL || 'https://app.circleci.com/pipelines/github/mm689/trove'
